var exports = {
  "rf": "xa15a2ab7--4d257a--body",
  "Sl": "xa15a2ab7--4d257a--image",
  "Cr": "xa15a2ab7--4d257a--bold",
};

module.exports = exports;
